import { render, staticRenderFns } from "./address-search.vue?vue&type=template&id=190c7f6e&"
import script from "./address-search.vue?vue&type=script&lang=js&"
export * from "./address-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports